import { reactive } from 'vue'

export default reactive({ setLanguage: "fr"})